import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Request, Response } from 'express';
import { MetaTagsService } from '../meta-tags/meta-tags.service';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  acceptedConsent: boolean = false;
  kbAutoWebsiteUrl: any = 'https://www.kbauto.ee'
  kbAutoPageObject = [
    {
      lang: 'de',
      pages: [
        {
          link: this.kbAutoWebsiteUrl + '/de',
          key: 'home'
        },
        {
          link: this.kbAutoWebsiteUrl + '/en/start-selling',
          key: 'startselling'
        },
        {
          link: this.kbAutoWebsiteUrl + '/de/about-us',
          key: 'aboutus'
        },
        {
          link: this.kbAutoWebsiteUrl + '/de/newsblog',
          key: 'newsblog'
        },
      ]
    },
    {
      lang: 'ee',
      pages: [
        {
          link: this.kbAutoWebsiteUrl + '/et',
          key: 'home'
        },
        {
          link: this.kbAutoWebsiteUrl + '/et/alusta-muuki',
          key: 'startselling'
        },
        {
          link: this.kbAutoWebsiteUrl + '/et/meist',
          key: 'aboutus'
        },
        {
          link: this.kbAutoWebsiteUrl + '/et/uudisedblogi',
          key: 'newsblog'
        },
      ]
    },
    {
      lang: 'en',
      pages: [
        {
          link: this.kbAutoWebsiteUrl + '/en',
          key: 'home'
        },
        {
          link: this.kbAutoWebsiteUrl + '/en/start-selling',
          key: 'startselling'
        },
        {
          link: this.kbAutoWebsiteUrl + '/en/about-us',
          key: 'aboutus'
        },
        {
          link: this.kbAutoWebsiteUrl + '/en/newsblog',
          key: 'newsblog'
        },
      ]
    },
    {
      lang: 'es',
      pages: [
        {
          link: this.kbAutoWebsiteUrl + '/es',
          key: 'home'
        },
        {
          link: this.kbAutoWebsiteUrl + '/en/start-selling',
          key: 'startselling'
        },
        {
          link: this.kbAutoWebsiteUrl + '/es/sobre-nosotros',
          key: 'aboutus'
        },
        {
          link: this.kbAutoWebsiteUrl + '/es/noticiasblog',
          key: 'newsblog'
        },
      ]
    },
    {
      lang: 'fi',
      pages: [
        {
          link: this.kbAutoWebsiteUrl + '/fi',
          key: 'home'
        },
        {
          link: this.kbAutoWebsiteUrl + '/en/start-selling',
          key: 'startselling'
        },
        {
          link: this.kbAutoWebsiteUrl + '/fi/meista',
          key: 'aboutus'
        },
        {
          link: this.kbAutoWebsiteUrl + '/fi/uutisetblogi',
          key: 'newsblog'
        },
      ]
    },
    {
      lang: 'no',
      pages: [
        {
          link: this.kbAutoWebsiteUrl + '/no',
          key: 'home'
        },
        {
          link: this.kbAutoWebsiteUrl + '/en/start-selling',
          key: 'startselling'
        },
        {
          link: this.kbAutoWebsiteUrl + '/no/om-oss',
          key: 'aboutus'
        },
        {
          link: this.kbAutoWebsiteUrl + '/no/nyheterblogg',
          key: 'newsblog'
        },
      ]
    },
    {
      lang: 'ru',
      pages: [
        {
          link: this.kbAutoWebsiteUrl + '/ru',
          key: 'home'
        },
        {
          link: this.kbAutoWebsiteUrl + '/en/start-selling',
          key: 'startselling'
        },
        {
          link: this.kbAutoWebsiteUrl + '/ru/o-nas',
          key: 'aboutus'
        },
        {
          link: this.kbAutoWebsiteUrl + '/ru/novostiblog',
          key: 'newsblog'
        },
      ]
    },
    {
      lang: 'se',
      pages: [
        {
          link: this.kbAutoWebsiteUrl + '/se',
          key: 'home'
        },
        {
          link: this.kbAutoWebsiteUrl + '/en/start-selling',
          key: 'startselling'
        },
        {
          link: this.kbAutoWebsiteUrl + '/se/om-oss-1',
          key: 'aboutus'
        },
        {
          link: this.kbAutoWebsiteUrl + '/se/nyheterblogg-1',
          key: 'newsblog'
        },
      ]
    },
  ]

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject('REQUEST') private req: Request,
    @Optional() @Inject('RESPONSE') private res: Response,
    @Inject(DOCUMENT) private document: Document,
    private http: HttpClient,
    private title: Title,
    private Meta: MetaTagsService,
  ) { }


  getFullUrl() {
    return this.document.location.href.replace('http://', 'https://');
  }
  getRequestData() {
    return this.req;
  }

  getRequestHostName() {
    return this.document.location.hostname;
  }

  getResponseData() {
    return this.res;
  }

  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  loadBidJsAuctions() {
    // const apiUrl = `https://lewes-staging.eu-west-2.staging.bidjs.com/auction-007/api/v1/models`;

    const headers = new HttpHeaders({
      'x-forwarded-client-id': 'machineric',
    });

    const apiUrl = `https://lewes-staging.eu-west-2.staging.bidjs.com/auction-007/api/v1/home?uid=20a11655-6208-44da-bd07-a93a3e3f53d71724758374821`

    return this.http.get(apiUrl, { headers });
  }

  loadBidJsAppKey() {
    const apiUrl = `https://develop-search-listener.eu-west-2.staging.bidjs.com/apikey.json`;

    return this.http.get(apiUrl);
  }

  getBidJsUserToken() {
    const apiUrl = `https://lewes-staging.eu-west-2.staging.bidjs.com/auction-007/api/v1/token`;

    let body = {
      "@class": "com.bidlogix.scaffold.models.user.LoginModel",
      "password": "1234",
      "username": "usman+bidder@machineric.com",
    }

    const headers = new HttpHeaders({
      'x-forwarded-client-id': 'machineric',
    });

    return this.http.post(apiUrl, body, { headers });
  }

  getSingleAuction(response: any) {
    const apiUrl = `https://lewes-staging.eu-west-2.staging.bidjs.com/auction-007/api/v3/auctions/cc8a2987-68cd-41fd-8c42-e5a5906b6c68`;

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${response.accessToken}`,
      'x-forwarded-client-id': 'machineric',
    });

    return this.http.get(apiUrl, { headers });
  }

  setMetaTags(title: string, description: string, imageUrl: string, url: string) {
    this.Meta.set({
      'title': title,
      'description': description,
      'og:title': title,
      'og:description': description,
      'og:image': imageUrl,
    })
  }

  parseLocationObject(location: any) {
    const { street, apartmentNumber, city, state, countryCode, zipCode } = location;
    // Create an array of formatted address parts
    const addressParts = [
      street || '',
      apartmentNumber || '',
      city || '',
      state || '',
      zipCode || '',
      countryCode || ''
    ];
    // Filter out empty parts and join with commas
    return addressParts.filter(part => part).join(', ');
  }

}
